<template>
  <div class="headder">
    <div class="head-cont clear">
      <div class="logo-lk fl">
        <a
          :href="baseUrl"
          class="logo-c"
        >
          <img
            v-if="logoUrl"
            :src="BASE_URL + logoUrl"
            alt="logo"
          >
          <img
            v-else
            src="../../../public/logo3.png"
            alt="logo"
          >
        </a>
        <a
          v-if="logoTxt"
          :href="baseUrl"
          class="logo-txt"
        >{{logoTxt}}</a>
        <i>·</i>
        <router-link
          :to="headOption.link"
          class="link-home"
        >{{headOption.title}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    headOption: {
      link: "/",
      title: "",
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      logoUrl: sessionStorage.getItem("logoUrl"),
      logoTxt: sessionStorage.getItem("logoTxt"),
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.headder {
  background: #fff;
  height: 80px;
  box-shadow: 0 2px 4px 0 rgba(195, 195, 195, 0.3);
}

.head-cont {
  padding: 15px 25px 0 25px;
}

.logo-lk {
  > a {
    line-height: 40px;
  }

  > i {
    margin: 0 5px;
    font-weight: bold;
  }
  .logo-c {
    display: inline-block;
    vertical-align: top;
    max-width: 180px;
    height: 40px;
    overflow: hidden;
    > img {
      width: 100%;
    }
    > span {
      font-size: 22px;
      margin: 0 5px 0 10px;
      font-weight: bold;
    }
  }

  .link-home {
    font-size: 16px;
    color: #000000;
    letter-spacing: 2px;
  }
}
</style>